import React from 'react'
import cn from 'classnames'
import { InfoModal } from 'components'
import { useModal } from 'hooks/useModal'
import { useTranslation } from 'react-i18next'
import classes from './Footer.module.scss'

export interface ImpressumModalProps {
  buttonText: string
}

export const ImpressumModal = () => {
  const [showModal, openModal, closeModal] = useModal()
  const { t } = useTranslation()

  return (
    <>
      <button
        className={cn(
          'wb-link',
          'wb-link--small',
          'wb-link--theme-dark',
          classes.button
        )}
        onClick={openModal}
      >
        {t('components.footer.impressumModal.buttonText')}
      </button>

      {showModal && (
        <InfoModal
          onClose={closeModal}
          headline={t('components.footer.impressumModal.heading')}
        >
          <p>
            {t('global.mbvm.name')} <br />
            {t('global.mbvm.streetAddress')} <br />
            {t('global.mbvm.zipcode')} {t('global.mbvm.city')} <br />
            {t('global.mbvm.country')} <br />
          </p>

          <p>
            {t('global.phone')}: {t('global.mbvm.phoneNumber')} <br />
            {t('global.email')}: {t('global.mbvm.customerServiceEmail')} <br />
          </p>

          <p>
            {t('global.mbvm.name')}
            {', '}
            {t('components.footer.impressumModal.legalDisclaimer')}
          </p>
        </InfoModal>
      )}
    </>
  )
}
